module.exports = "https://coursera_assets.s3.amazonaws.com/images/f57194af82042b4f988e98cfe54a97d8.png";